<template>
  <div id="casesDetail">
    <bread :content="breadContent"></bread>
    <p class="Page-title">
      {{ pageTypeCN[pageState] }}
      <span class="title--inactive" @click="changeState((pageState + 1) % 3)">{{ pageTypeCN[(pageState + 1) % 3] }}</span>
      <span class="title--inactive" @click="changeState((pageState + 2) % 3)">{{ pageTypeCN[(pageState + 2) % 3] }}</span>
    </p>
    <el-divider></el-divider>
    <div class="body">
      <div class="body-left">
        <Article :margin="'20px 0 0 0'" :title="title" :authors="authors" :secondAuthors="secondAuthors" :html="html" :class="showReadMore ? 'hide-article' : ''"></Article>
        <div class="shadow" v-if="showReadMore"></div>
        <div v-if="showReadMore" class="read-more" @click="clickReadMore">
          <el-divider>阅读全文</el-divider>
        </div>
        <div class="bottom">
          <div class="download" @click="clickDownload">
            <img src="@/assets/pdf.png" class="icon">
            PDF下载</div>
          <!-- <div class="info">页数：{{ pageNum }} 大小：{{ fileSize }}</div> -->
        </div>
      </div>
      <div class="body-right">
        <timeblock :list="timeblockData"></timeblock>
      </div>
    </div>
  </div>
</template>
<script>
import bread from "@/components/bread";
import Article from '@/components/article'
import timeblock from '@/components/timeblock'
import Api from '@/network'

export default {
  name: "casesDetail",
  components: {
    bread,
    Article,
    timeblock
  },
  data() {
    return {
      pageState: 0,
      pageTypeCN: ['应急法律法规', '应急管理案例', '应急管理论文'],
      pageType: ['laws', 'cases', 'papers'],
      title: '',
      authors: '',
      secondAuthors: '',
      html: '',
      timeblockData: [],
      downloadUrl: '',
      // pageNum: 5,
      // fileSize: '100k'
    }
  },
  computed: {
    breadContent(){
      return [
        { text: "首页", routerName: "index" },
        { text: "学习资料与案例库", routerName: "dataAndCases" },
        { text: this.pageTypeCN[this.pageState], routerName: "" },
      ]
    },
    showReadMore() {
      return !localStorage.Authorization
    }
  },
  watch: {
   '$route'(){
     this.$router.go(0)
   }
  },
  methods: {
    changeState(newPageState) {
      this.pageState = newPageState
      this.$router.push({params: {type: this.pageType[newPageState]}})
    },
    clickDownload() {
      if (!this.downloadUrl) {
        // 如果未登录后端返回此属性为空
        if (localStorage.Authorization) {
          alert('编辑未提供下载文件')
        } else {
          alert('登陆后才可以下载该资料！')
        }
      } else {
        window.open(this.downloadUrl)
      }
    },
    clickReadMore() {
      alert('请先登录')
      this.$store.commit('changeLoginButton')
    },
    async loadTimeblock() {
      const type = this.$route.params.type
      console.log(this.$route.params.type)
      let res
      /*switch (type) {
        case 'laws':
          res = await this.$net.dataAndCases.getLaws()
          break
        case 'cases':
          res = await this.$net.dataAndCases.getCases()
          break
        case 'papers':
          res = await this.$net.dataAndCases.getPapers()
          break
    }*/
      res=await this.$net.index.getLast('case');
      let data = []
      res.forEach(item => {
        data.push({
          date: item.Date,
          content: item.Title,
          url: `/dataAndCases/${type}/detail?id=${item.Id}`
        })
      })
      this.timeblockData = data
    }
  },
  async beforeRouteEnter(to, from, next) {
    const res = await Api.dataAndCases.getDetail(to.query.id)
    next(vm => {
      vm.title = res.Title
      vm.authors = res.Author
      vm.secondAuthors = res.Source // 暂时填个坑
      vm.html = res.Content
      vm.downloadUrl = res.DownloadUrl
      vm.loadTimeblock()
    })
  }
}
</script>
<style lang="scss" scoped>
#casesDetail {
  width: 75%;
  margin-left: 15%;
  margin-top: 80px;
  margin-bottom: 200px;
  .title--inactive {
    font-size: 18px;
    color: #000;
    margin-left: 20px;
    cursor: pointer;
  }
  .body {
    display: flex;
    justify-content: space-around;
  }
  .body-left {
    position: relative;
    width: 70%;
    margin-left: 5%;
    .read-more * {
      color: $standard-blue;
      font-size: 18px;
      cursor: pointer;
    }
    .shadow {
      position: absolute;
      height: 100px;
      width: 100%;
      margin-top: -100px;
      background: linear-gradient(180deg, #ffffff00, #ffffff);
      z-index: 1;
    }
  }
  .bottom {
    text-align: right;
    margin-top: 50px;
    margin-right: 15%;
    .download {
      display: inline-flex;
      align-items: center;
      font-size: 20px;
      color: #0087d3;
      cursor: pointer;
    }
    .icon {
      width: 30px;
      height: 30px;
      margin-right: 10px;
    }
    // .info {
    //   display: inline-block;
    //   margin-left: 50px;
    //   font-size: 14px;
    //   color: #0087d3;
    //   letter-spacing: 1px;
    // }
  }
  .hide-article {
    height: 250Px;
    overflow: hidden;
  }
}
</style>

